import { render, staticRenderFns } from "./warrantyRecord.vue?vue&type=template&id=5cb15ad1&scoped=true&"
import script from "./warrantyRecord.vue?vue&type=script&lang=js&"
export * from "./warrantyRecord.vue?vue&type=script&lang=js&"
import style0 from "./warrantyRecord.vue?vue&type=style&index=0&id=5cb15ad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb15ad1",
  null
  
)

export default component.exports